import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import styled from "styled-components";
import { ResultHeader } from "@witbooking/react-components";
import media from "../../utils/media";
import constants from "../../utils/constants";

const StyledResultHeader = styled(ResultHeader)`
  border-bottom: none;
  margin-bottom: 0;
  ${props => props.hasBackButton && `margin-left: -10px`} ${media.up.md`
    padding: 0;
    margin-bottom: 10px;
  `};
`;

function EntityResultHeader({
  entity,
  nature,
  onImageClick,
  onBack,
  onHeaderClick,
  hasBackButton,
  subtitle,
}) {
  if (!entity) {
    return null;
  }
  return (
    <StyledResultHeader
      nature={nature}
      hasBackButton={hasBackButton}
      title={entity.name}
      subtitle={subtitle}
      image={entity.media && entity.media[0] && entity.media[0].url}
      onClick={onHeaderClick}
      onImageClick={event =>
        onImageClick(entity.media, entity.name, entity.description, null, null, null, event)
      }
      onBack={onBack}
    />
  );
}

EntityResultHeader.propTypes = {
  //   /** Prop which holds the property information */
  entity: PropTypes.object,
  /** The component can have different appearances depending on this prop  */
  nature: PropTypes.oneOf([
    constants.RESULT_HEADER_NATURE.SMALL,
    constants.RESULT_HEADER_NATURE.MEDIUM,
    constants.RESULT_HEADER_NATURE.LARGE,
  ]),
  /** Function to be executed when clicking the back button */
  onBack: PropTypes.func.isRequired,
  /** Function to be executed when clicking in the result's header */
  onHeaderClick: PropTypes.func,
  /** Function to be executed when clicking in property image */
  onImageClick: PropTypes.func.isRequired,
  /** Button bar node / content */
  hasBackButton: PropTypes.bool,
  /** Node that lists rooms */
  subtitle: PropTypes.string,
};

export default pure(EntityResultHeader);
